<mat-card class="card">
  <mat-card-content>
    <!-- <mat-grid-list> -->
    <!-- <huge-row *ngIf='deviceDetails["UnknownTower"]'>
            <mat-col class="text-align-center mat-align-items-center">
                <mat-icon name="warning-outline" color="danger" style="vertical-align: middle;"></mat-icon>
                <p color="danger" style="vertical-align: middle;">Device is currently at an unknown tower</p>
            </mat-col>
        </huge-row> -->
    <huge-row>
      <mat-col>
        <div>
          @if (data.DeviceNumber) {
          <huge-row>
            <mat-col style="text-align: left;">
              <p>Device Num:</p>
            </mat-col>
            <mat-col style="text-align: right;">
              <span class="primary">{{ data?.DeviceNumber }}</span></mat-col>
          </huge-row>
          }
          <huge-row>
            <mat-col size="6" style="text-align: left;">
              <p>Terminal ID:</p>
            </mat-col>
            <mat-col style="text-align: right;">
              <div class="primary" style="display: flex; justify-content: flex-end;">
                <div>
                  {{ data.TerminalID != null && data.TerminalID != '' ? data.TerminalID : 'Not set' }}
                </div>
                <div>
                  @if (!data.isKA&& userHasWriteAccess && data.kaID==null){
                  <mat-icon class="edit" (click)="openEditDevice()" style="font-size: 18px;">create</mat-icon>
                  }
                </div>
              </div>
            </mat-col>
          </huge-row>
          @if (data.DeviceType) {
          <huge-row>
            <mat-col style="text-align: left;">
              <p>Device Type:</p>
            </mat-col>
            <mat-col style="text-align: right;">
              <span class="primary">{{ data?.DeviceType }}</span>
            </mat-col>
          </huge-row>
          } @if (data.Manufacturer != null) {
          <huge-row>
            <mat-col style="text-align: left;">
              <p>Manufacturer:</p>
            </mat-col>
            <mat-col style="text-align: right;">
              <span class="primary">{{ data.Manufacturer }}</span>
            </mat-col>
          </huge-row>
          } @if (data.DeviceStatus != null) {
          <huge-row>
            <mat-col style="text-align: left;">
              <p>Device Status:</p>
            </mat-col>
            <mat-col style="text-align: right;"><span class="primary">{{ data.DeviceStatus }}</span></mat-col>
          </huge-row>
          } @if (data.FormattedInBundleAmount != null) {
          <huge-row>
            <mat-col style="text-align: left;">
              <p>Data Bundle:</p>
            </mat-col>
            <mat-col style="text-align: right;">
              <span class="primary">{{ data.FormattedUsage }} / {{ data.FormattedInBundleAmount }}</span>
            </mat-col>
          </huge-row>
          } @if (data.Reference != null) {
          <huge-row>
            <mat-col style="text-align: left;">
              <p>Reference:</p>
            </mat-col>
            <mat-col style="text-align: right;"><span class="primary">{{ data.Reference }}</span></mat-col>
          </huge-row>
          }
          <huge-row>
            <mat-col size="6" style="text-align: left;">
              <p>Merchant:</p>
            </mat-col>
            <mat-col style="text-align: right;">
              <div class="primary" style="display: flex; justify-content: flex-end;">
                <div>
                  {{ data.MerchantName != null && data.MerchantName != '' ? data.MerchantName : 'Not set' }}
                </div>
                <div>
                  @if (!data.isKA && userHasWriteAccess) {
                  <mat-icon class="edit" (click)="openEditDevice()" style="font-size: 18px;">create</mat-icon>
                  }
                </div>
              </div>
            </mat-col>
          </huge-row>
          <huge-row>
            <mat-col size="6" style="text-align: left;">
              <p>Serial Number:</p>
            </mat-col>
            <mat-col style="text-align: right;">
              <div class="primary" style="display: flex; justify-content: flex-end;">
                <div>
                  {{ data.SerialNumber != null && data.SerialNumber != '' ? data.SerialNumber : 'Not set' }}
                </div>
                <div>
                  @if (!data.isKA && userHasWriteAccess && data.kaID==null) {
                  <mat-icon class="edit" (click)="openEditDevice()" style="font-size: 18px;">create</mat-icon>
                  }
                </div>
              </div>
            </mat-col>
          </huge-row>
          @if (data.AvgCSQ != null) {
          <huge-row>
            <mat-col style="text-align: left;">
              <p>Avg CSQ:</p>
            </mat-col>
            <mat-col style="text-align: right;"><span class="primary">{{ data.AvgCSQ }}</span></mat-col>
          </huge-row>
          } @if (data.IP != null) {
          <huge-row>
            <mat-col style="text-align: left;">
              <p>IP:</p>
            </mat-col>
            <mat-col style="text-align: right;"><span class="primary">{{ data.IP }}</span></mat-col>
          </huge-row>
          } @if (data.Cluster != null) {
          <huge-row>
            <mat-col style="text-align: left;">
              <p>Reporting on:</p>
            </mat-col>
            <mat-col style="text-align: right;"><span class="primary">{{ data.Cluster }}</span></mat-col>
          </huge-row>
          } @if (data.KillswitchEnabled != null && data.IsMikrotik != null && data.IsMikrotik) {
          <huge-row>
            <mat-col style="text-align: left;">
              <p>Killswitch:</p>
            </mat-col>
            <mat-col style="text-align: right;">
              <span class="primary">{{ data.KillswitchEnabled == true ? 'Enabled' : 'Disabled' }}</span>
            </mat-col>
          </huge-row>
          } @if (data.IMEI != null) {
          <huge-row>
            <mat-col style="text-align: left;">
              <p>IMEI:</p>
            </mat-col>
            <mat-col style="text-align: right;"><span class="primary">{{ data.IMEI }}</span></mat-col>
          </huge-row>
          }
          <!-- <huge-row *ngIf='deviceDetails["AcquiringBank"] != null'>
                      <mat-col><p>Acquiring Bank:</p></mat-col>
                      <mat-col><span class="primary">{{deviceDetails?.AcquiringBank}}</span></mat-col>
                  </huge-row> -->
          <!-- <huge-row *ngIf='deviceDetails["TerminalType"] != null'>
                      <mat-col><p>Terminal Type:</p></mat-col>
                      <mat-col><span class="primary">{{deviceDetails?.TerminalType}}</span></mat-col>
                  </huge-row> -->

          <!-- <huge-row *ngIf='deviceDetails["MerchantID"] != null'>
                      <mat-col><p>Merchant ID:</p></mat-col>
                      <mat-col><span class="primary">{{deviceDetails?.MerchantID}}</span></mat-col>
                  </huge-row> -->
          <!-- <huge-row *ngIf='deviceDetails["MerchantName"] != null'>
                      <mat-col><p>Merchant Name:</p></mat-col>
                      <mat-col><span class="primary">{{deviceDetails?.MerchantName}}</span></mat-col>
                  </huge-row> -->
          <!-- <huge-row *ngIf='deviceDetails["SequenceNumber"] != null'>
                      <mat-col><p>Sequence Number:</p></mat-col>
                      <mat-col><span class="primary">{{deviceDetails?.SequenceNumber}}</span></mat-col>
                  </huge-row> -->
          <!-- <huge-row *ngIf='deviceDetails["TerminalSupplier"] != null'>
                      <mat-col><p>Terminal Supplier:</p></mat-col>
                      <mat-col><span class="primary">{{deviceDetails?.TerminalSupplier}}</span></mat-col>
                  </huge-row> -->
          <!-- <huge-row *ngIf='deviceDetails["TowerMCC"] != null'>
                      <mat-col><p>MCC/Country Code:</p></mat-col>
                      <mat-col><span class="primary">{{deviceDetails?.TowerMCC}} / {{deviceDetails?.TowerCountryCode}}</span></mat-col>
                  </huge-row> -->
          <!-- <huge-row *ngIf='deviceDetails["TowerCountryCode"] != null'>
                      <mat-col><p>Country Code:</p></mat-col>
                      <mat-col><span class="primary">{{deviceDetails.TowerCountryCode}}</span></mat-col>
                  </huge-row> -->
        </div>
      </mat-col>
      <!-- <mat-col> -->
      <!-- <div> -->

      <!-- <huge-row *ngIf='deviceDetails["Customer"] != null'>
                        <mat-col><p>Customer:</p></mat-col>
                        <mat-col><span class="primary">{{ deviceDetails["Customer"] }}</span></mat-col>
                    </huge-row>
                    <huge-row *ngIf='deviceDetails["LastPing"] != null'>
                        <mat-col><p>Last Activity:</p></mat-col>
                        <mat-col><span class="primary" *ngIf="!deviceDetails['LastPing']">Unknown</span><span *ngIf="deviceDetails['LastPing']" class="primary">{{deviceDetails["LastPing"] | date:'yyyy/MM/dd HH:mm:ss':'short'}}</span></mat-col>
                    </huge-row> -->
      <!-- <huge-row *ngIf='deviceDetails["LastPing"]'>
                        <mat-col><p>Last Ping:</p></mat-col>
                        <mat-col><span class="primary" *ngIf="!deviceDetails['LastPing']">Unknown</span><span *ngIf="deviceDetails['LastPing']" class="primary">{{deviceDetails["LastPing"] | timeAgo}}</span></mat-col>
                    </huge-row>
                    <huge-row *ngIf='deviceDetails["LastSnapshot"]'>
                        <mat-col><p>Last Snapshot:</p></mat-col>
                        <mat-col><span class="primary" *ngIf="!deviceDetails['LastSnapshot']">Unknown</span><span *ngIf="deviceDetails['LastSnapshot']" class="primary">{{deviceDetails["LastSnapshot"] | timeAgo}}</span></mat-col>
                    </huge-row> -->

      <!-- <huge-row *ngIf='deviceDetails["SCID"] != null'>
                        <mat-col><p>SCID</p></mat-col>
                        <mat-col><span class="primary">{{deviceDetails.SCID}}</span></mat-col>
                    </huge-row>

                    <huge-row *ngIf='deviceDetails["AvgCSG"] != null'>
                        <mat-col><p>Avg/Last CSQ</p></mat-col>
                        <mat-col><span class="primary">{{deviceDetails.AvgCSG}} / {{deviceDetails.LastCSG}}</span></mat-col>
                    </huge-row>
                    <huge-row *ngIf='deviceDetails["MaxLatency"] != null'>
                        <mat-col><p>Avg/Max/Last Latency:</p></mat-col>
                        <mat-col><span class="primary">{{deviceDetails.AvgLatency}} / {{deviceDetails.MaxLatency}} / {{deviceDetails.LastLatency}}</span></mat-col>
                    </huge-row>
                    <huge-row *ngIf='deviceDetails["TowerCellID"] != null'>
                        <mat-col><p>Cell ID:</p></mat-col>
                        <mat-col><span class="primary">{{deviceDetails.TowerCellID}}</span></mat-col>
                    </huge-row>
                    <huge-row *ngIf='deviceDetails["TowerLAC"] != null'>
                        <mat-col><p>LAC:</p></mat-col>
                        <mat-col><span class="primary">{{deviceDetails.TowerLAC}}</span></mat-col>
                    </huge-row>
                    <huge-row *ngIf='deviceDetails["TotalTx"] != null'>
                        <mat-col><p>Total Tx/Rx:</p></mat-col>
                        <mat-col><span class="primary">{{deviceDetails.TotalTx}} / {{deviceDetails.TotalRx}}</span></mat-col>
                    </huge-row> -->
      <!-- <huge-row *ngIf='deviceDetails["TotalRx"] != null'>
                        <mat-col><p>Total Rx:</p></mat-col>
                        <mat-col><span class="primary">{{deviceDetails.TotalRx}}</span></mat-col>
                    </huge-row> -->
      <!-- <huge-row *ngIf='deviceDetails["LastComms"]'>
                        <mat-col><p>Last Comms:</p></mat-col>
                        <mat-col><span class="primary" *ngIf="!deviceDetails['LastComms']">Unknown</span><span *ngIf="deviceDetails['LastComms']" class="primary">{{deviceDetails["LastComms"] | timeAgo}}</span>/mat-col>
                    </huge-row> -->
      <!-- <huge-row *ngIf='deviceDetails["TowerLat"] != null'>
                        <mat-col><p>Lat/Long:</p></mat-col>
                        <mat-col><span class="primary">{{deviceDetails.TowerLat}} / {{deviceDetails.TowerLong}}</span></mat-col>
                    </huge-row> -->
      <!-- <huge-row *ngIf='deviceDetails["TowerLong"] != null'>
                        <mat-col><p>Longitude:</p></mat-col>
                        <mat-col><span class="primary"></span></mat-col>
                    </huge-row> -->
      <!-- </div> -->

      <!-- </mat-col> -->
    </huge-row>
    <!-- </mat-grid-list> -->
  </mat-card-content>
</mat-card>
